import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { M365Range } from './model';
import { EntityStatus, initialStatus } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'm365Ranges';

export interface State extends EntityState<M365Range>, EntityStatus {}

export const adapter = createEntityAdapter<M365Range>({
    selectId: (item: M365Range) => item.network,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadM365Ranges, (state) => ({
        ...state,
        loading: true,
    })),
    on(actions.loadM365RangesSuccess, (state, { data }) =>
        adapter.setAll(data, {
            ...state,
            loading: false,
            loaded: true,
        }),
    ),
    on(actions.loadM365RangesFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false,
        updating: false,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
